<template>
  <tbody class="bg-white border-b border-slate-200 last:border-0">
    <tr>
      <td
        class="py-3 px-6 text-xs font-normal text-slate-950 font-mono break-words align-top leading-tight"
      >
        {{ name }}
      </td>
      <td
        class="py-3 px-6 text-xs font-normal text-slate-950 break-words align-top leading-tight"
      >
        {{ provider }}
      </td>
      <td
        class="py-3 px-6 text-xs font-normal text-slate-950 align-top leading-tight"
      >
        {{ purpose }}
      </td>
    </tr>
  </tbody>
</template>
<script setup lang="ts">
defineProps<{
  name: string;
  provider: string;
  purpose: string;
}>();
</script>
<style scoped>
td {
  @apply border-0;
  position: initial !important;
}
tbody td:nth-child(-n + 2) {
  @apply border-r-0;
}
</style>
